import React, { Component } from "react";
import { IconButton, Grid, Card, Icon, withStyles } from "@material-ui/core";
import * as actions from "../../store/actions/index";
import { connect } from "react-redux";
import { compose } from "redux";
import ListComponent from "../Common/ListComponent";

import { from } from "apollo-boost";
import { fr } from "date-fns/locale";

const IconSmall = withStyles(() => ({
  root: {
    fontSize: "1.5rem",
    color: "rgba(0, 0, 0, 0.6)",
  },
}))(Icon);

class ProfileRight extends Component {
  state = {
    attachment: null,
    activedatas: [],
    updatelistorder: true,
    task_id:"",
  };

  componentDidMount() {
    let val = { recordtypeid: 1 };
    this.props.getRelatedMasterList(this.props.apolloClient.client, val);
    if(this.props.task_id){
        this.setState({
            task_id:this.props.task_id,
        },()=>{
            this.forceUpdate()
        });
    }
  }
  componentWillReceiveProps(props) {
    console.log("props", props);
      if(props.task_id){
          this.setState({
              task_id:props.task_id,
          },()=>{
              this.forceUpdate()
          });
      }
    if (props.settingReducer.leadrelatedMaster.data) {
      const leadrelatedMaster = props.settingReducer.leadrelatedMaster.data;
      let activedatas = [];

      leadrelatedMaster.map((fieldData, index) => {
        if (fieldData.isactive === true) {
          activedatas.push({
            key: fieldData.id,
            alias: fieldData.alias,
            isactive: fieldData.isactive,
            orderid: fieldData.orderno,
          });
        }
      });
      if (this.state.updatelistorder == true)
        this.setState({ activedatas: activedatas }, () => this.forceUpdate());
    }
  }

  render() {
    return (
      <>
        <ListComponent activedata={this.state.activedatas} allData={this} />
      </>
    );
  }
}
const mapStateToProps = (state) => {
  return {
    settingReducer: state.settingReducer,
    apolloClient: state.apolloClient,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    getRelatedMasterList: (client, request) => {
      dispatch(actions.getRelatedMasterList(client, request));
    },
  };
};

export default compose(connect(mapStateToProps, mapDispatchToProps))(
  ProfileRight
);
